import { getHumanizationDatabase } from "./humanizationDatabase";

const WORD_PATTERN = /^(\p{L}+)([^\p{L}]*)$/u;

function keepCase(originalWord, replacementWord) {
  if (!originalWord) {
    return replacementWord;
  }

  if (originalWord === originalWord.toUpperCase()) {
    return replacementWord.toUpperCase();
  }

  if (originalWord[0] === originalWord[0].toUpperCase()) {
    return `${replacementWord.charAt(0).toUpperCase()}${replacementWord.slice(1)}`;
  }

  return replacementWord;
}

export function replaceSynonym(token, random, probability = 0.3) {
  if (!token || !token.trim()) {
    return token;
  }

  const parts = token.match(WORD_PATTERN);
  if (!parts) {
    return token;
  }

  const [, word, suffix] = parts;
  const candidates = getHumanizationDatabase().synonyms[word.toLowerCase()];

  if (!candidates || random() >= probability) {
    return token;
  }

  const pick = candidates[Math.floor(random() * candidates.length)];
  return `${keepCase(word, pick)}${suffix || ""}`;
}
